/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import { useUserStore, useDashboardStore } from '../../../store/models';

function useAnalyticsConnect() {
    const userStore = useUserStore();
    const dashboardStore = useDashboardStore();
    const [isLoading, setIsLoading] = useState(false);
    const [albatoEmbedURL, setAlbatoEmbedURL] = useState(null);

    useEffect(() => {
        if (userStore.publisher) {
            loadConnectToken();
        }
    }, [userStore.observed.publisher]);

    useEffect(() => {
        if (dashboardStore.albatoEmbedURL) {
            console.log('useAnalyticsConnect() -> ', dashboardStore.albatoEmbedURL);
            setAlbatoEmbedURL(dashboardStore.albatoEmbedURL);


        }
    }, [dashboardStore.observed.albatoEmbedURL]);

    async function loadConnectToken () {
        await dashboardStore.getAlbatoToken();
    }

    return {
        isLoading,
        setIsLoading,
        albatoEmbedURL,
    };
}

export default useAnalyticsConnect;
